export default __webpack_public_path__ + "static/service_03-057b05fea9dfec80658dc951f3d9c409.jpg";